import React, { Component } from 'react';
import LeadDates from '../../components/leadtracker/LeadDates';
import { Button } from '@blueprintjs/core';
import InputText from '../../components/blueprintWrappers/InputText';

class EditLead extends Component {

	render() {
		const { complete, companyName, contactFirstName, contactLastName, contactPhone, contactEmail,
			contactNotes, actionItem, details, leadDateProps, onChange, setComplete, setIncomplete, save, goBack } = this.props;

		return (
			<div >
				<div> EDIT LEAD </div>

				<div >
					Company Name
				</div>
				<InputText
					value={companyName}
					placeholder="..."
					onChange={(text) => onChange(text, 'companyName')}
				/>

				<div>
					First Name
				</div>

				<InputText
					value={contactFirstName}
					placeholder="..."
					onChange={(text) => onChange(text, 'contactFirstName')}
				/>

				<div>
					Last Name
				</div>

				<InputText
					value={contactLastName}
					placeholder="..."
					onChange={(text) => onChange(text, 'contactLastName')}
				/>

				<div >
					Contact Phone
				</div>
				<InputText
					value={contactPhone}
					placeholder="..."
					onChange={(text) => onChange(text, 'contactPhone')}
				/>

				<div >
					Contact Email
				</div>
				<InputText
					value={contactEmail}
					placeholder="..."
					onChange={(text) => onChange(text, 'contactEmail')}
				/>

				<div>
					Contact Notes
				</div>
				<InputText
					value={contactNotes}
					placeholder="..."
					onChange={(text) => onChange(text, 'contactNotes')}
				/>

				<div >
					Action Item
				</div>
				<InputText
					value={actionItem}
					placeholder="..."
					onChange={(text) => onChange(text, 'actionItem')}
				/>

				<div>
					Details
				</div>
				<InputText
					value={details}
					placeholder="..."
					onChange={(text) => onChange(text, 'details')}
				/>

				<LeadDates {...leadDateProps} />

				<div>
					<Button /* TODO styling or toggle effect */
						onClick={setComplete}
						label="Complete"
						className={complete === 'Y' ? 'pt-intent-success' : 'pt-intent-danger'}
					> Complete
				</Button>
					<Button
						onClick={setIncomplete}
						label="Not Complete"
						className={complete === 'N' ? 'pt-intent-success' : 'pt-intent-danger'}
					> Not Complete
				</Button>

					<Button onClick={save} >
						Save
				</Button>

					<Button onClick={goBack} >
						Cancel
				</Button>
				</div>
			</div>

		);
	}
}

export default EditLead;


// WEBPACK FOOTER //
// ./src/components/leadtracker/EditLead.js